"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _vuex = require("vuex");
var _v = _interopRequireDefault(require("uuid/v4"));
var _timeUtil = require("@/utils/time-util");
var _apolloClient = require("@/apollo/apolloClient");
var _clientQuery = require("@/apollo/queries/client-query");
var _clientMutation = require("@/apollo/mutations/client-mutation");
var _auth = require("@/utils/auth");
var _appUtil = require("@/utils/app-util");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import BackToTop from '@/components/BackToTop'
var _default = exports.default = {
  components: {/* BackToTop */},
  data: function data() {
    return {
      sendingMassage: false,
      scroll_top: 0,
      searching: '',
      activeCategory: [],
      inputMessage: '',
      chatMsgs: [],
      interval: null,
      mes_count: 0,
      baackToTopStyle: {
        right: '20px',
        bottom: '260px',
        width: '40px',
        height: '40px',
        'border-radius': '4px',
        'line-height': '45px',
        background: '#e7eaf1'
      },
      roomData: {
        site_user_id: '',
        client: '',
        admin: '',
        category: '',
        charge_avatar: ''
      },
      chatRoom: {}
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapState)({
    sidebar: function sidebar(state) {
      return state.app.sidebar;
    },
    device: function device(state) {
      return state.app.device;
    }
  })), {}, {
    classObj: function classObj() {
      return {
        openSidebar: this.sidebar.opened,
        hideSidebar: !this.sidebar.opened,
        mobile: this.device === 'mobile'
      };
    }
  }),
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this = this;
      var client_info, res, _t;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return _apolloClient.apolloClient.queryManager.pollingInfoByQueryId.forEach(function (val, key) {
              _apolloClient.apolloClient.queryManager.stopPollingQuery(key);
            });
          case 1:
            _context.next = 2;
            return _apolloClient.apolloClient.resetStore();
          case 2:
            _context.next = 3;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.CLIENT_QUERY,
              variables: {
                uid: (0, _auth.getUUID)()
              }
            });
          case 3:
            client_info = _context.sent;
            this.$data.roomData.client = client_info.data.client_user[0].company_name;
            this.$data.roomData.admin = 'ファーストスタッフ';
            _context.next = 4;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.CHAT_CLIENT_MESSAGE_QUERY,
              variables: {
                client_uid: (0, _auth.getUUID)()
              }
            });
          case 4:
            res = _context.sent;
            this.$data.chatMsgs = res.data.client_message;
            this.$nextTick(function () {
              var container = _this.$el.querySelector('#vscr');
              container.scrollTop = container.scrollHeight;
            });
            if (!this.interval) {
              _context.next = 5;
              break;
            }
            _context.next = 5;
            return clearInterval(this.interval);
          case 5:
            this.interval = setInterval(this.message_update, 1000);
            _context.next = 6;
            return _apolloClient.apolloClient.mutate({
              mutation: _clientMutation.CLEAR_CLIENT_CHAT_COUNT,
              variables: {
                client_uid: (0, _auth.getUUID)()
              }
            }).then(function (res) {
              _apolloClient.apolloClient.resetStore();
            }).catch(function (error) {
              console.log(error);
              _this.$notify({
                title: '失敗',
                message: 'データベースの更新に失敗しました',
                type: 'error',
                duration: 5000
              });
            });
          case 6:
            _context.next = 7;
            return (0, _appUtil.checkReadingFlag)(true);
          case 7:
            _t = _context.sent;
            if (!(_t === true)) {
              _context.next = 8;
              break;
            }
            this.$store.dispatch('app/setKey', (0, _v.default)());
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  destroyed: function () {
    var _destroyed = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!this.interval) {
              _context2.next = 1;
              break;
            }
            _context2.next = 1;
            return clearInterval(this.interval);
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function destroyed() {
      return _destroyed.apply(this, arguments);
    }
    return destroyed;
  }(),
  beforeDestroy: function () {
    var _beforeDestroy = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _this2 = this;
      var _t2;
      return regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!this.interval) {
              _context3.next = 1;
              break;
            }
            _context3.next = 1;
            return clearInterval(this.interval);
          case 1:
            _context3.next = 2;
            return _apolloClient.apolloClient.queryManager.pollingInfoByQueryId.forEach(function (val, key) {
              _apolloClient.apolloClient.queryManager.stopPollingQuery(key);
            });
          case 2:
            _context3.next = 3;
            return _apolloClient.apolloClient.resetStore();
          case 3:
            _context3.next = 4;
            return _apolloClient.apolloClient.mutate({
              mutation: _clientMutation.CLEAR_CLIENT_CHAT_COUNT,
              variables: {
                client_uid: (0, _auth.getUUID)()
              }
            }).then(function (res) {
              _apolloClient.apolloClient.resetStore();
            }).catch(function (error) {
              console.log(error);
              _this2.$notify({
                title: '失敗',
                message: 'データベースの更新に失敗しました',
                type: 'error',
                duration: 5000
              });
            });
          case 4:
            _context3.next = 5;
            return (0, _appUtil.checkReadingFlag)(false);
          case 5:
            _t2 = _context3.sent;
            if (!(_t2 === true)) {
              _context3.next = 6;
              break;
            }
            this.$store.dispatch('app/setKey', (0, _v.default)());
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function beforeDestroy() {
      return _beforeDestroy.apply(this, arguments);
    }
    return beforeDestroy;
  }(),
  methods: {
    displayDateTime: function displayDateTime(dateTime, format) {
      return (0, _timeUtil.displayDateTime)(dateTime, format);
    },
    message_update: function () {
      var _message_update = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var container, result, res;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              console.log('message_update');
              _context4.next = 1;
              return _apolloClient.apolloClient.resetStore();
            case 1:
              container = this.$el.querySelector('#vscr');
              if (this.scroll_top !== container.scrollHeight) {
                container.scrollTop = container.scrollHeight;
                this.scroll_top = container.scrollHeight;
              }
              _context4.next = 2;
              return _apolloClient.apolloClient.query({
                query: _clientQuery.CHAT_MESSAGES_COUNT,
                variables: {
                  client_uid: (0, _auth.getUUID)()
                }
              });
            case 2:
              result = _context4.sent;
              if (!(this.mes_count !== result.data.client_message_aggregate.aggregate.count)) {
                _context4.next = 4;
                break;
              }
              console.log('change');
              _context4.next = 3;
              return _apolloClient.apolloClient.query({
                query: _clientQuery.CHAT_CLIENT_MESSAGE_QUERY,
                variables: {
                  client_uid: (0, _auth.getUUID)()
                }
              });
            case 3:
              res = _context4.sent;
              this.mes_count = result.data.client_message_aggregate.aggregate.count;
              this.$data.chatMsgs = res.data.client_message;
              _context4.next = 4;
              break;
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function message_update() {
        return _message_update.apply(this, arguments);
      }
      return message_update;
    }(),
    displayExchangeTarget: function displayExchangeTarget(owner, admin) {
      var target = '';
      if (admin) {
        "".concat(admin.name, "\u21C4").concat(owner);
      } else {
        target = "".concat(owner, "\u306E\u30C1\u30E3\u30C3\u30C8\u30EB\u30FC\u30E0");
      }
      return target;
    },
    displayMsgTime: function displayMsgTime(dateTime) {
      return (0, _timeUtil.displayChatTime)(dateTime);
    },
    goToChatCharge: function goToChatCharge() {
      return this.$router.push({
        name: 'ChatStaffIndex'
      });
    },
    onSendMessage: function () {
      var _onSendMessage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this3 = this;
        var message_txt;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.sendingMassage = true;
              if (!(this.inputMessage === '')) {
                _context5.next = 1;
                break;
              }
              this.sendingMassage = false;
              this.$notify({
                title: 'エラー',
                message: 'メッセージが入力されていません。',
                type: 'error',
                duration: 5000
              });
              return _context5.abrupt("return");
            case 1:
              message_txt = this.inputMessage;
              _context5.next = 2;
              return _apolloClient.apolloClient.mutate({
                mutation: _clientMutation.ADD_CHAT_MESSAGE,
                variables: {
                  message: message_txt,
                  from_user_type: 2,
                  client_uid: (0, _auth.getUUID)(),
                  admin_uid: null
                }
              }).then(function (res) {
                _apolloClient.apolloClient.resetStore();
                _this3.sendingMassage = false;
                _this3.inputMessage = '';
              }).catch(function (error) {
                _this3.sendingMassage = false;
                console.log(error);
                _this3.$notify({
                  title: '失敗',
                  message: 'メッセージを送信できませんでした。',
                  type: 'error',
                  duration: 5000
                });
              });
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function onSendMessage() {
        return _onSendMessage.apply(this, arguments);
      }
      return onSendMessage;
    }()
  }
};